import React from "react";
import { Row, Col } from "react-bootstrap";
import _omit from "lodash/omit";

export default function StartupDashboardWidget(props) {
  const { id, children, header, subHeader } = props;
  return (
    <div id={id} className="dashboard-box">
      <Row className="dashboard-box-header-row">
        <Col md={6} className="dashboard-box-header">
          {header}
        </Col>
        <Col md={6} className="dashboard-box-subheader">
          {subHeader}
        </Col>
      </Row>
      <Row
        className="dashboard-box-content-row"
        {..._omit(props, ["id", "header", "subHeader"])}
      >
        {children}
      </Row>
    </div>
  );
}
